import React from 'react';
import {
  Button,
  createStyles,
  makeStyles,
  useMediaQuery
} from '@material-ui/core';
import { t } from 'src/i18n';

interface IProps {
  onClick(): void;
  isEnable: boolean;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      backgroundColor: '#2F68FD',
      display: 'flex',
      borderRadius: '15px',
      minWidth: '90px',
      height: (props: any) => {
        if (props.isTablet) return '40px';

        return '58px';
      },
      width: (props: any) => {
        if (props.isTablet) return '170px';

        return '315px';
      },
      margin: '10px auto',
      '&:hover': {
        backgroundColor: '#023EE3'
      }
    },
    buttonTitle: {
      color: '#fff',
      'font-size': '20px',
      'font-family': 'TTCommons',
      'letter-spacing': '0',
      'line-height': '24px',
      'margin-bottom': '0',
      'margin-top': '4px',
      'text-transform': 'none'
    }
  })
);

const TryAgainButton: React.FC<IProps> = ({ isEnable = false, onClick }) => {
  const matches = useMediaQuery('(max-width:768px)');
  const isIpadLg = useMediaQuery('(max-width:1024px)');

  const isTablet = matches || isIpadLg;
  const classes = useStyles({ isTablet });

  return isEnable ? (
    <Button className={classes.button} color={'primary'} onClick={onClick}>
      <p className={classes.buttonTitle}>{t('general.tryAgain')}</p>
    </Button>
  ) : (
    <></>
  );
};

export default TryAgainButton;
